import toPairs from 'lodash/toPairs'
import { parse } from 'query-string'
import * as ReduxObservable from 'redux-observable'
import { filter, map , mergeMap, tap} from 'rxjs/operators'
import {SAME_TAB, TAB_SELECTED } from 'store'
import { getRouteSequence, SIGNUP_ROUTES } from '../constants'
import { getRouteProgressPath, setQueryParams, SIGNUP_STEPS } from '../generic/utils'
import * as Router from '../router'
import { clearFullStorage } from '../storage/utils'
import * as Actions from './actions'
import {APP_ENTER_STARTED, REPLACE_PARAMS, UPDATE_URL} from './constants'

const bypassStepRoutePath = [
  SIGNUP_ROUTES.VERIFY_EMAIL,
]

const allowChangingRoutePath = [
  SIGNUP_ROUTES.ACCOUNT,
  SIGNUP_ROUTES.CANSPAM,
  SIGNUP_ROUTES.EMAIL_PREFERENCES,
]

export const onEnter: ReduxObservable.Epic = (action$, state$, {history}) =>
  action$.ofType(Router.ON_ENTER)
    .pipe(
      map(() => {
        return { type: APP_ENTER_STARTED }
      }),
    )

export const handleStepRoute: ReduxObservable.Epic = (action$, state$, {history}) =>
  action$.ofType(APP_ENTER_STARTED)
    .pipe(map(() => {
        if (history.location.pathname === SIGNUP_ROUTES.BASE) {
          const query: any = parse(history.location.search)
          setQueryParams(query)
        }
      }),
      map(() => getRouteProgressPath()),
      filter((path) => {
        const query: any = parse(history.location.search)
        if (allowChangingRoutePath.includes(history.location.pathname) && allowChangingRoutePath.includes(path) &&
          getRouteSequence(history.location.pathname) < getRouteSequence(path)) {
            return false
        }
        return path !== history.location.pathname && ((path === SIGNUP_ROUTES.BILLING) ||
          ((query.onboarding_status === SIGNUP_STEPS.VERIFY_EMAIL ||
              !bypassStepRoutePath.includes(history.location.pathname)) &&
          (path === SIGNUP_ROUTES.VERIFY_EMAIL ? query.c || query.email : true)))
      }),
      map(() => {
        return Router.push(`${getRouteProgressPath()}`)
      }),
    )

export const handleStorageRefresh: ReduxObservable.Epic = (action$, state$, {history}) =>
  action$.ofType(Router.ON_ENTER)
    .pipe(
      map((action) => (new window.URLSearchParams(window.location.search))),
      filter((params: any) => {
        return params.get('refresh')
      }),
      map(() => clearFullStorage()),
      map(() => getRouteProgressPath()),
      mergeMap(() => [
        Router.push(`${getRouteProgressPath()}`),
      ]),
    )

const onTabSelected: ReduxObservable.Epic = (action$) =>
  action$.ofType(TAB_SELECTED).pipe(
    map((action: any) => {
      if (window.location.hash !== `#${action.hash}`) {
        return Actions.updateUrl(null, action.hash)
      }
      return {type: SAME_TAB}
    }),
  )

const onUpdateUrl: ReduxObservable.Epic =
  (action$, store, { window }) =>
    action$.ofType(UPDATE_URL).pipe(
    map((action: any) => ({ action, params: new window.URLSearchParams(window.location.search) })),
    tap(({ action, params }) =>
      toPairs(action.params).map(([key, value]) =>
        params.has(key) ?
        params.set(key, value) :
        params.append(key, value))),
    // delete params with no value
    tap(({ action, params }) =>
      toPairs(action.params)
        .filter(([key, value]) => !value)
        .filter(([key, value]) => params.has(key))
        .map(([key, value]) => params.delete(key))),
    mergeMap(({ action, params }) => [
      Router.replace(`${window.location.pathname}${params ? `?${params}` : ''}${action.hash ? `#${action.hash}` : ''}`),
      // Actions.urlParsed(fromPairs(Array.from(params.entries()))),
    ]),
    )

const onReplaceParams: ReduxObservable.Epic =
  (action$, store, { window }) =>
    action$.ofType(REPLACE_PARAMS).pipe(
    map((action: any) => ({ action, params: new window.URLSearchParams()})),
    tap(({ action, params }) =>
      toPairs(action.params).map(([key, value]) =>
        params.append(key, value))),
    mergeMap(({ action, params }) => [
      Router.replace(`${window.location.pathname}${params ? `?${params}` : ''}${action.hash ? `#${action.hash}` : ''}`),
      // Actions.urlParsed(fromPairs(Array.from(params.entries()))),
    ]),
    )

export const epic = ReduxObservable.combineEpics(
  handleStepRoute,
  handleStorageRefresh,
  onEnter,
  onReplaceParams,
  onTabSelected,
  onUpdateUrl)
